'use client';

import { type ReactNode } from 'react';
import { ColorModeProvider, type ColorMode } from './ColorModeProvider';
import { DensityProvider, type Density } from './DensityProvider';

export interface ThemeProviderProps {
  initialMode?: ColorMode;
  initialDensity?: Density;
  children: ReactNode;
}

export function ThemeProvider({
  initialMode = 'auto',
  initialDensity = 'comfortable',
  children,
}: ThemeProviderProps) {
  return (
    <ColorModeProvider initialMode={initialMode}>
      <DensityProvider initialDensity={initialDensity}>{children}</DensityProvider>
    </ColorModeProvider>
  );
}
